/**
 * @file: 购物车 商品列表
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/02/28      1.0     First version
 *
 * @param saleFromType=="0" 普通商品，!(item.saleFromType==='0'&&item.isInvalid==1)不显示的逻辑，现在是if失效else基本不往下走，所以 忽略
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React,{PureComponent}  from "react";
import PropTypes from "prop-types";
import moment from 'moment';
import { Empty,Checkbox, Affix, Spin,Pagination} from 'antd';
import IconTips from "../iconTips/iconTips";
// import NewLabel from "../../../../common/components/react/NewLabel"; 版权风险暂不用
import PopQuestion from '../PopQuestion/PopQuestion';//提问组件
// import SimpleRightPagination from "../../../../common-antd/oneComponents/Pagination/SimpleRightPagination";//简单的右对齐页码组件
import Attributes from "../attributes/attributes";
import Lang from "@components/Lang/Lang";
import Locale from '@/utils/locale'
import { toFixed2, symbolMoneyUtil,} from '@utils/utils';
import {IconXunjiazhong, IconGongYingShang, IconWraning, IconJiangJia,IconXiaoLian} from "../svgIcon/SvgIcon";
import Image from "../image";
import "./list.less";
const config = require("../../../../../config/config");
let locale = Locale.current();

export default class CommonList extends PureComponent {
    static propTypes = {
        list: PropTypes.array,
    };
    static defaultProps = {
        list: [],
        extra:{}
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            checkAll: false,
            checkSupplierMap: props.checkSupplierMap,//选择列表 一维
            errorItemsMap: {}, //异常回调显示
            selectedItems: {}, //选中的商品 {id: true/false}
        }
        this.__getServerLanguage = __getServerLanguage;
        this.user = {};

    }

    // 处理单个商品勾选
    handleSkuCheck = (skuId, checked) => {
        const { list } = this.props;
        const { selectedItems } = this.state;
        
        const newSelectedItems = {
            ...selectedItems,
            [skuId]: checked
        };
        
        // 检查是否全部选中
        const allChecked = list.length > 0 && list.every(item => newSelectedItems[item.id]);
        
        this.setState({
            selectedItems: newSelectedItems,
            checkAll: allChecked
        }, () => {

        });
    }

    // 处理全选
    handleCheckAll = (checked) => {
        const { list } = this.props;
        const newSelectedItems = {};
        list.forEach(item => {
            newSelectedItems[item.id] = checked;
        });
        this.setState({
            selectedItems: newSelectedItems,
            checkAll: checked
        }, () => {
            // 触发父组件回调
            // if (this.props.onSelectionChange) {
            //     this.props.onSelectionChange(newSelectedItems);
            // }
        });
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 商品栏 头部 提示
     * @param moqCanNotOrder  起订量不足,将无法下单,请先调整订购量
     * */
    renderOrderTips(item,moqCanNotOrder=false){
        const skuIsInvalid = item.isInvalid==1||item.joinGroupExpire==1;// 失效 或者 拼团失效
        // 该商品价格已过期，如需下单请重新确认 GaiShangPinYiGuoJiaGeBaoH1
        // 过期商品多少天后删除 ||
        const expiredProduct = (item.isExpired==1&&item.isInvalid!=1)?this.__getServerLanguage("TianHouZiDongShanChu",item.remainDayForExpired):"";
        //失效商品多少天后删除
        const invalidProduct = item.isInvalid==1?this.__getServerLanguage("TianHouZiDongShanChu",item.remainDayForInvalid):"";
        return (<>
            {/* 商品已失效 isInvalid 是否失效 1 失效*/}
            {skuIsInvalid?<div className={"tips tipsGrey flex-item-ver-center"}>
                <IconWraning size={12} /> {this.__getServerLanguage("ShangPinYiShiXiao")}
            </div>:<>
                {/*  确认生产要求中 */}
                {item.inqStatus==='1'&&!this.user.role&&<div className={"tips tipsBlue"}>
                    <IconXunjiazhong size={12} />
                    {this.__getServerLanguage("QueRenShengChanYaoQiuZhon")}
                    {/* 低于MOQ */}
                    {item.intentQuantity&&<span>({this.__getServerLanguage("DiYuMOQ")})</span>}
                    {/* 正在向工厂确认生产要求  */}
                    <span className={"black45 margin-left-s"}>{this.__getServerLanguage("GongChangYuJiXiaoShiNeiQu")}</span>
                </div>}
                {/*  已确认：可下单*/}
                {item.inqStatus==='2'&&!moqCanNotOrder && !this.user.role&&<div className={"tips"}>
                    <span className="iconfont icon-xunjiawancheng"></span>
                    {this.__getServerLanguage("YiQueRenKeXiaDan")}
                    {/* 价格保护期 start */}
                    {/* GaiShangPinYiGuoJiaGeBaoH1  该商品价格已过期，如需下单请重新确认 &&!(item.saleFromType==='0'&&item.isInvalid==1) 忽略 失效已有判断*/}
                    {item.remainPriceSaveDay<1&&item.isShowPriceSaveDay!==0&&<span className={"black45 margin-left-s"}>
                            {this.__getServerLanguage("GaiShangPinYiGuoJiaGeBaoH1")}
                        {/*{item.cartExpiredDay>0&&<span class="icon-img icon-qa-normal-round price-safe" data-expired-day={item.cartExpiredDay||'--'}></span>} 目前UI沒有此項*/}
                            </span>}
                    {/* 商品价格保护还剩{0}天。保护期内价格不会改变. start  &&!(item.saleFromType==='0'&&item.isInvalid==1)  忽略 失效已有判断 */}
                    {item.remainPriceSaveDay>0&&item.isShowPriceSaveDay!==0&&<span className={"black45 margin-left-s"}>
                              {this.__getServerLanguage("JiaGeBaoHuQiShengYuNTian2",item.remainPriceSaveDay)}
                           </span> }
                    {/* 价格保护期 end */}
                    {expiredProduct&&<span className={"black45 margin-left-s"}>{expiredProduct}</span>}
                    {invalidProduct&&<span className={"black45 margin-left-s"}>{invalidProduct}</span>}
                </div>}
                {/* 已确认，增加购买箱数可下单 | 出现情况 工厂回复了询价，但要求的MOQ，比客户加购数量大 */}
                { item.inqStatus==='2'&& moqCanNotOrder && !this.user.role&&<div className={"tips flex-item-between align-items-center"}>
                    <div>
                        <span className="iconfont icon-xunjiawancheng"></span>
                        {this.__getServerLanguage("YiQueRenZengJiaGouMaiXiangShuKeXiaDan")}
                        {expiredProduct&&<span className={"black45 margin-left-s"}>{expiredProduct}</span>}
                        {invalidProduct&&<span className={"black45 margin-left-s"}>{invalidProduct}</span>}
                    </div>
                    {/* 不满足工厂起订量要求 */}
                    <span className="moqErr">{this.__getServerLanguage("BuManZuGongChangQiDingLiangYaoQiu")}</span>
                </div>
                }
            </> }

        </>)
    }
    /**
     * 渲染 商品 购买信息 数量\价格
     * @param moqCanNotOrder   起订量不足,将无法下单
     *
     * ------------ DOP 无 ----------
     * @param sendFeed 均摊的运费
     *
     * */
    renderBuyNum(item={},proSendFeed=0,moqCanNotOrder=false){
        const {extra={} } = this.props;
        const flagGroup = item.isJoinGroup == 1; //拼团商品
        // isInvalid 是否失效 | joinGroupExpire 拼团失效| moqException 是否MOQ异常 1时表示MOQ异常 | inqStatus -1：询价超时过期（服务商专用） 0：未询价 ， 1：询价中， 2：询价完成 | activityStatus 20 [活动]中 30[活动 ]洽谈中 40[活动]失败 50 [活动]成功 60 [活动]关闭
        let iPrice = (item.priceException == 1 && item.comparePrice) ? item.comparePrice : item.price; // 单价
        let iTotalPrice = item.totalPrice;
        let priceOneFee = 0
        // if(proSendFeed>0){
        //     priceOneFee = toFixed2(proSendFeed/item.skuCapacity/item.quantity);
        //     if(priceOneFee<0.01){ priceOneFee = 0.01};
        //     iPrice= toFixed2(priceOneFee+iPrice);
        //     iTotalPrice = toFixed2(iPrice*item.skuCapacity*item.quantity);
        // }
        const showMoqErr = item.inqStatus==='2'&&moqCanNotOrder;//&& !this.user.role;// 询价完成 &&item.saleFromType=='0'现只有普通商品 , this.user.role 都是为空的
        const priceMoqIngErr = item.inqStatus==='1'&&moqCanNotOrder;//&& !this.user.role;// 询价中的 &&item.saleFromType=='0'
        return (<div className={"buyNumInfo"}>
            {/* 主信息显示 start */}
            <div className={"flex-item-between"}>
                <div className={`quantityArea`}>
                    <div className={"optionBtn"}>
                        {item.quantity}
                    </div>
                    {showMoqErr&&<div className={"black45 font_12 mt_6"}>MOQ {item.moq}</div>}
                </div>
                <div>
                    {/* 低于Moq 提示 购买箱数小于工厂要求，等待工厂确认中*/}
                    {priceMoqIngErr&&<IconTips content={<div className={"popPriceTips black66"}>
                        {this.__getServerLanguage("GouMaiXiangShuXiaoYuGongChangYaoQiu")}
                    </div>} iconClassName={"black45"} className={"float-right ml_8"}/>}
                    {/* 低于Moq 提示 购买箱数小于工厂要求*/}
                    {showMoqErr&&<IconTips content={<div className={"popPriceTips black66"}>
                        {this.__getServerLanguage("GouMaiXiangShuXiaoYuGongChangYaoQiu2")}
                    </div>} iconClassName={"black45"} className={"float-right ml_8"}/>}
                </div>
                <div className={"quantityArea mr_8"}>
                    {/* 总个数  划过提示 */}
                    <IconTips content={<div className={"black66"}>
                        {/* 装量 */}
                        <div className={"fw_700 black89"}>{this.__getServerLanguage("ZhuangLiang")}</div>
                        <div className="font-12 margin-top-s">
                            <span className={"fw_700 black89 mr_6"}>{item.skuCapacity || '-'}</span>{item.packageTypeName} / {this.__getServerLanguage("WaiXiang")}
                        </div>
                        {item.skuCount>1&&<div className="margin-top-s font-12">
                            <span className={"fw_700 black89 mr_6"}>{item.skuCount}</span>PCS / {item.packageTypeName}
                        </div>}
                    </div>} iconClassName={"ml_5 black45"}>
                        <span className={"black89"}>{(item.skuCapacity*item.quantity)||'--'}</span>
                    </IconTips>
                    <p className={"ml_16 black45 font-12"}>{item.packageTypeName||this.__getServerLanguage('Ge')}</p>
                </div>
                {/* 价格 相关 !(item.priceException==1&&item.comparePrice) */}
                <div className={"priceArea"}>
                    {/* 总价 */}
                    {iTotalPrice?<div className="fw_700 font-16 black89">
                            {symbolMoneyUtil(iTotalPrice || '--',extra.currencySymbol)}
                        </div>:<div className={"deleteText"}>
                            {/* 未核价   {this.__getServerLanguage("WeiHeJia")} 改为显示删除线 */}
                            {symbolMoneyUtil(iTotalPrice,extra.currencySymbol)}
                        </div>}
                    {/* 单价 划过提示 商品报价 */}
                    <div className={"font-12 black66"}>
                        {item.price? <IconTips content={<div className={"popPriceTips"}>
                            <div className={"flex-item-between"}>
                                <span className={"black89"}> {this.__getServerLanguage("ShangPinBaoJia")}</span>
                                <span className={"black66"}>
                                    {symbolMoneyUtil(item.saleBasePrice || '--',extra.currencySymbol)}
                                     </span>
                            </div>
                            <div className={"line"}></div>
                            {/* 物流清关费 已无 "f" == $scope.parame.query.quoteType ? `${__getServerLanguage("FOBJunTan")} ${_symbol} ${item.fob} 忽略 */}
                            <div className={"flex-item-between"}>
                                <span className={"black89"}> {this.__getServerLanguage("WuLiuQingGuanFei")}</span>
                                <span className={"black66"}>
                                    {symbolMoneyUtil(item.logisticsPrice || '--',extra.currencySymbol)}
                                     </span>
                            </div>
                            {priceOneFee>0?<div className={"line"}></div>:null}
                            {priceOneFee>0?<div className={"flex-item-between"}>
                                <span className={"black89"}> {this.__getServerLanguage("QiSongFei")}</span>
                                <span className={"black66"}>
                                    {symbolMoneyUtil(priceOneFee || '--',extra.currencySymbol)}
                                </span>
                            </div>:null}
                            {/* 物流清关费 起送费 */}
                        </div>} iconClassName={"ml_5 black45"}>
                            <span className={"mr_6"}>{this.__getServerLanguage("DanJia")}</span>
                            {symbolMoneyUtil(iPrice || '--',extra.currencySymbol)}
                            {/*<SymbolMoney price={this.userSetting.ddpClearanceType==10 &&item.spuCopyright==4 ?'--' : (iPrice || "--")} />*/}
                            {priceOneFee>0?<span className={"color-red2 fw_700"}>(+  {symbolMoneyUtil(priceOneFee || '--',extra.currencySymbol)})</span>:null}
                        </IconTips>:
                            <div className={"deleteText"}>
                                {symbolMoneyUtil(item.price,extra.currencySymbol)}
                                {/*this.__getServerLanguage("WeiHeJia")*/}
                            </div>}
                    </div>
                    {/* YiSheng 升价不显示 降价显示 */}
                    {item.differencePrice<0&&<span className="labelDown font-12">
                                <IconJiangJia size={9} />
                                <span>
                                    {this.__getServerLanguage("YiJiangJia")}
                                </span>
                                {symbolMoneyUtil(Math.abs(item.differencePrice) || '--',extra.currencySymbol)}
                           </span>}
                    {/* CanKaoJia DDP 没有忽略 */}
                    {!flagGroup&&<PopQuestion btnClass={'btn_ques mt_8'}
                                              product={item}
                                              inCart={'1'}
                                              cartId={item.id}
                                              skuId={item.skuId}
                                              buyerId={item.buyerId}
                                              buyerAccountId={item.buyerAccountId}
                                              brandId={item.brandId}
                                              iconSvg = {<IconXiaoLian size={14} />}
                                              tipsNum={item.inqCount}
                                              hotDotShow={item.answerCount&&item.answerCount>0}
                                              title={this.__getServerLanguage("ZiXunChanPin")} />}
                </div>
            </div>
            {/* 主信息显示 end */}
        </div>)
    }

    /**
     * 请求
     * */
    postHttpAction(sUrl,data,callback){
        return $.ajax({
            url: sUrl,
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify(data),
            success:(res)=>{
                callback(res)
            }
        });
    }
    /*
    * 修改页码
    * */
    onChangePage(page, pageSize){
        if(this.props.getListByPage)this.props.getListByPage(page)
    }

    /**
     * 渲染一个商品
     * @param item      商品信息
     * @param flagGroup 是否拼团商品
     * --- DOP 无 ------------
        checkSku 是否勾选
        sendFeed 均摊的运费
     *
     * */
    renderPro(sku,checkSku=false,proSendFeed=0){
        const { errorItemsMap,} = this.state;
        const errSku = errorItemsMap[sku.id];//异常提示
        const flagGroup = sku.isJoinGroup == 1; //拼团商品
        const joinGroupGoodsDetailVO = sku.saleJoinGroupGoodsDetailVO || {};
        const groupTime = flagGroup?joinGroupGoodsDetailVO.groupTime:0;
        const skuIsInvalid = sku.isInvalid==1||sku.joinGroupExpire==1;// 失效 或者 拼团失效
        const moqCanNotOrder = sku.moqException!=1&&(sku.quantity<sku.moq)?true:false; // 起订量不足,将无法下单,请先调整订购量
        return (<div className={"mt_12 flex-item"} key={sku.id}>
            <div className={`proWrap proWrapId_${sku.id}${checkSku&&errSku?" errPro":(checkSku?" selectPro":"")}`}>
                {/* 渲染商品 下单提示信息  */}
                {this.renderOrderTips(sku,moqCanNotOrder)}
                {/* 渲染商品 */}
                <div className={"flex-item proMain"}>
                    <Checkbox
                        checked={checkSku}
                        onChange={(e) => this.handleSkuCheck(sku.id, e.target.checked)}
                        className="mr_12"
                    />
                    {/* 商品图片 失效 或者 拼团失效 都显示失效样式 */}
                    {skuIsInvalid?<div className={"mr_12 proMainImg proMainImgInvalid"}>
                        <Image src={sku.imgUrl} alt={sku.name} width={120} isInvalid={true} />
                    </div>:<div className={"mr_12"}>
                        <div className={`proMainImg${flagGroup?" picProGroup":""}${groupTime>0?" picProGroupIng":""}`}>
                            <Image src={sku.imgUrl} alt={sku.name} width={120} className={"pic"} />
                            {/* 拼团 倒计时*/}
                            {flagGroup&&<div className={"bottom"}>
                                {/*<IconGroup size={46} className={"iconGroup"} />*/}
                                {joinGroupGoodsDetailVO.iconUrl&&<img src={joinGroupGoodsDetailVO.iconUrl} width={36} />}
                            </div>}
                            {/*{flagGroup&& groupTime>0?<div className={"bottomRed"}>*/}
                                {/*<CountTimeDown endTime={groupTime} langMap={this.__getServerLanguage()} />*/}
                            {/*</div>:null}*/}
                        </div>
                    </div>}
                    {/* 商品其他信息 */}
                    <div className={"otherWrap flex-item-between"}>
                        {/* 标题 标签属性 更多等信息 */}
                        <div className={"info mr_12"}>
                            {/* 标题 */}
                            <div className={"title flex-item"}>
                                <a href={`${config.essaone[locale]}/${sku.spuId}.html?skuNo=${sku.skuNo}`} className={"black89 ellipsis name"} target="_blank"
                                   title={sku.name}>
                                    {sku.name}
                                </a>
                                <span className={"black45 margin-left-s"}>{sku.createTime?moment(sku.createTime).format('YYYY-MM-DD'):""}</span>
                            </div>
                            {/* 标签 此处只会有一个标签 可能有版权风险 list={params.data.labelList} */}
                            {/*<NewLabel copyright={sku.spuCopyright} hasCertificate={sku.hasCertificate} className={"mt_6"}>*/}
                                {/*/!* 工厂有好推荐 改为只展示 标签<div class="factory-recommendation-container" ng-if="item.isRecommend===1" id="goods-factory-recommendation-view-{{sku.id}}" data-index="{{$index}}"></div> *!/*/}
                                {/*{sku.isRecommend===1&&<span className={"labelRecommend"}>{this.__getServerLanguage("GongChangYouHaoTuiJian2",sku.recommendTotal||0)}</span>}*/}
                            {/*</NewLabel>*/}
                            {/* 渲染属性 */}
                            {<Attributes sku={sku} />}
                        </div>
                        {/* 标题 标签属性 更多等信息 END */}
                        {/* 购买信息 */}
                        {this.renderBuyNum(sku,proSendFeed,moqCanNotOrder)}
                        {/* 购买信息 END */}
                    </div>
                    {/* 商品其他信息 END*/}
                </div>
            </div>
        </div>)
    }
    // 外部获取勾项 用
    getSelectItems(){
        const {selectedItems={}} =this.state;
       return selectedItems
    }
    componentDidMount() {
        if( this.props.onRef)this.props.onRef(this);
    };
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { list,} =this.props;
        const {loading, checkAll=false,selectedItems} =this.state;
        return (<>
            <div className={`proWrapHeader flex-item-between flex-item-ver-center`}>
                {/* 全选 */}
                <Checkbox checked={checkAll} onChange={(e)=>this.handleCheckAll(e.target.checked)}>{Lang({id: 'QuanXuan', default: '全选'})}</Checkbox>
                <span className={"flex-1"}>{Lang({id: 'ShangPinXinXi', default: '商品信息'})}</span>
                <div className={"other flex-item-between"}>
                    <div className={"w50 mr_12"}></div>
                    {/* 购买信息 */}
                    <div className={"w50 flex-item-between"}>
                            <div className={`quantityArea`}>
                                {Lang({id:'DingGouLiang',default:'订购量'})}
                            </div>
                            <div className={"quantityArea mr_8"}>
                                {Lang({id: 'ZongGeShu', default: '总个数'})}
                            </div>
                            <div className={"priceArea"}>
                                {Lang({id: 'JinE', default: '金额'})}
                            </div>
                    </div>

                </div>
            </div>
            {list.length>0?<Spin spinning={loading}>
            <div className="wpbox shopping-cart-warp">
                {/* 商品信息 */}
                {list.map((pro,inx)=>{
                    return this.renderPro(pro,selectedItems[pro.id])
                })}
            </div>
        </Spin>:<div className="wpbox shopping-cart-warp">
                {/* GouWuCheNeiZanShiMeiYouSh2 在DOP 改为 暂无数据*/}
            <Empty description={this.__getServerLanguage("ZanWuShuJu")}>
            </Empty>
        </div>}
        </>);
    }
}
